var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{expanded:!_vm.isCollapseNavLeft, isMobile: _vm.isMobile},attrs:{"id":"app"}},[_c('NavLeft',{staticClass:"navLeft",attrs:{"isCollapseNavLeft":_vm.isCollapseNavLeft},on:{"setCollapse":_vm.setCollapse}}),_c('NavTop'),_c('div',{staticClass:"main-container"},[_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }